import { cx } from "@linaria/core";
import { useMDXComponents } from "@mdx-js/react";
import { Code } from "timvir/blocks";
import * as React from "react";
import * as Icons from "react-feather";
interface Props {
  src: string;
  code?: string;
}
function Caption(props: Props) {
  const components = {
    a: "a",
    ...useMDXComponents()
  };
  const {
    src,
    code
  } = props;
  const [codeRef, setCodeRef] = React.useState<null | HTMLDivElement>(null);
  return <>
      <figcaption className={"fgdj0yb"}>
        <div>
          Source:{" "}
          <components.a href={src} target="_blank">
            {src}
          </components.a>
        </div>

        {code && <div className={"d1rc4zjh"} onClick={() => {
        if (codeRef) {
          const infoParent = codeRef.parentElement!;
          if (infoParent.style.height === "0px") {
            infoParent.style.height = `${codeRef.getBoundingClientRect().height}px`;
            infoParent.style.opacity = "1";
          } else {
            infoParent.style.height = "0px";
            infoParent.style.opacity = "0";
          }
        }
      }}>
            <Icons.Code size={"1.6em"} />
          </div>}
      </figcaption>

      {code && <div className={cx("d1enfo6")} style={{
      height: 0,
      opacity: 0
    }}>
          <div ref={setCodeRef} className={cx("d1watfn6")}>
            <Code language="jsx">{code}</Code>
          </div>
        </div>}
    </>;
}
export default React.memo(Caption);

require("./Caption.linaria.module.css!=!../../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Caption.tsx");